<template>
    <div class="mb-1" id="mainHeader">
        <!-- <upper-header class="sticky-header"
                    v-bind:skin="skin" 
                    v-bind:language="language" 
                    v-bind:translation="translation"
                    @login-upper-header="login"
                    @register-upper-header="register"
      ></upper-header> -->
        <div style="position: relative;">
            <span class="m-1" style="position: absolute; right: 20px; top: 10px;">
                <a v-if="skin.redes.facebook.enabled" target="_blank" :href="skin.redes.facebook.url" class="me-2"
                    :style="skin.redes.facebook.btn_style"><i class="fab fa-facebook-square" aria-hidden="true"></i></a>
                <a v-if="skin.redes.instagram.enabled" target="_blank" :href="skin.redes.instagram.url" class="me-2"
                    :style="skin.redes.instagram.btn_style"><i class="fab fa-instagram-square"
                        aria-hidden="true"></i></a>
                <a v-if="skin.redes.tiktok.enabled" target="_blank" :href="skin.redes.tiktok.url" class="me-2"
                    :style="skin.redes.tiktok.btn_style"><i class="fab fa-tiktok"></i></a>
                <a v-if="skin.redes.twitter.enabled" target="_blank" :href="skin.redes.twitter.url" class="me-2"
                    :style="skin.redes.twitter.btn_style"><i class="fab fa-twitter-square" aria-hidden="true"></i></a>
                <a v-if="skin.redes.youtube.enabled" target="_blank" :href="skin.redes.youtube.url" class="me-2"
                    :style="skin.redes.youtube.btn_style"><i class="fab fa-youtube-square" aria-hidden="true"></i></a>
            </span>
        </div>
        <div>
            <!-- Button trigger modal -->
            <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
                style="display:none;"></button>
            <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
                style="display:none;"></button>
            <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <!-- <button id="chanpass_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#changePassword" style="display:none;"></button> -->
            <!-- <change-password v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" v-bind:user="user"/> -->
            <register ref="register" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <div class="center_div d-flex justify-content-start navbar-og" style="background: #ffffff1a;">
                <div v-for="(item,index) in filteredCategories" :key="index" @click="change_view(index)"
                    :style="[hoverCss, activeColor]" style="cursor:pointer;display:flex;align-items: center;"
                    :class="['px-2', 'pe-2', 'text-center', 'navbar-op', { active: item.url === $store.state.infoRouter.url }]">
                    <span :style="skin.header_desktop.nav_bar_text">
                        <i :class="item.icon"></i>{{ translate(item.name) }}
                    </span>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import login from "./mainheader/login.vue";
import register from './mainheader/register.vue';
import changePassword from './mainheader/change_password.vue';
import languageSelector from './language.vue';
import UpperHeader from "./UpperHeader.vue";

export default {
    name: "mainHeader",
    props: {
        skin: Object,
        language: String,
        translation: Object
    },
    data() {
        return {
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
        }
    },
    components: {
        login,
        register,
        changePassword,
        languageSelector,
        UpperHeader
    },
    methods: {
        navegacionInitdetalle() {
            // console.log("navegando navegando navegando navegando navegando navegando ");        
            let control = this.$store.getters['getDataDetalleDataPrimeraVezAction'];
            // console.log("control de prinerva vez 11111111 antes de navegar", control, "position");
            this.$store.dispatch("setDataDetalleDataPrimeraVezAction", false);
            // console.log("control de prinerva vez 11111111 despues de navegar", control, "position");
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                //let domain_formated = "admin.championred.bet";
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        register() {
            document.getElementById('register_btn').click();
        },
        chanpass() {
            document.getElementById('chanpass_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        my_account() {
            window.parent.postMessage(
                {
                    action: 'openSlider',
                    tab: 'recentBets'
                },
                '*'
            );
        },
        change_view(view) {
            this.$store.dispatch("changeView", view);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        changeBalanceView() {
            let balance = 0;
            let disponible = 0
            if (this.config.SkinConfig.main.newbonus ? this.$store.getters['getConfig'].SkinConfig.main.newbonus : false) {
                balance = this.user.user_data.data.available_balance + this.user.user_data.data.bonus + this.user.user_data.data.frozen;
                disponible = this.user.user_data.data.available_balance;
            }
            else {
                balance = this.user.user_data.data.balance;
                disponible = this.user.user_data.data.bonus_balance;
            }
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            if (this.balance.switch == 0) {
                this.balance.saldo = balance;
                this.balance.conversion = (this.currency.fiat != 'BETC' ? (this.currency.fiat == 'USDT' ? balance * tasa : balance * tasa * this.user.user_data.data.tasa) : balance).toFixed(2);
                this.balance.view = "SALDO";
                this.balance.switch = 1;
            }
            else {
                this.balance.saldo = disponible;
                this.balance.conversion = (this.currency.fiat != 'BETC' ? (this.currency.fiat == 'USDT' ? balance * tasa : balance * tasa * this.user.user_data.data.tasa) : balance).toFixed(2);
                this.balance.view = "DISPONIBLE";
                this.balance.switch = 0;
            }
        },
    },
    computed: {
        filteredCategories() {
            return this.$props.skin.categories.filter(category => category.active);
        },
        actualRoute() {
            return this.$store.getters["getActualRoute"]
        },
        mainColor() {
            return {
                '--mainBackColor': this.$props.skin.main_color_1
            }
        },
        hoverCss() {
            return {
                '--activeHover': this.$props.skin.main_active_1,
            }
        },
        activeColor() {
            return {
                '--activeMainColor': this.$props.skin.main_active_1,
            }
        },
        user() {
            let config = this.$store.getters['getConfig'];
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = config.SkinConfig.main.newbonus ? data.user_data.data.available_balance + data.user_data.data.bonus + data.user_data.data.frozen : data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
            }
            return data;
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
        header_productsQty() {
            let products = [this.$props.skin.poker, this.$props.skin.prematch, this.$props.skin.casinoN, this.$props.skin.casino_live, this.$props.skin.hipicas, this.$props.skin.login, this.$props.skin.logout];
            return products.filter(x => x == true).length + 1;
        },
        config() {
            return this.$store.getters['getConfig'];
        },
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight);
    },
}
</script>

<style scoped>
.center_div {
    width: 100%;
    height: auto;
    margin: 0 auto;
    padding: 0px;
    position: relative;
}

.navbar-og {
    border-start-start-radius: 4px;
    /* background: #ffffff1a; */
    border-end-start-radius: 4px;
}

.navbar-op {
    background: transparent;
    font-size: 14px;
    height: 34px;
}

.navbar-op {
    position: relative;
}

.navbar-op::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1.8px;
    background-color: transparent;
    transition: background-color 0.3s;
}

.navbar-op:hover::before {
    background-color: var(--activeHover);
}

/* .navbar-op:hover {
          background: var(--activeHover);
      } */
.navbar-op i {
    margin-inline-end: 10px;
}

.navbar-op.active {
    /* background-color: #fff200; */
    background: var(--activeMainColor);
}

.navbar-op.active span {
    color: black !important;
}

.navbar-op.active:hover {
    background-color: var(--activeHover);
    /* DEL SKIN */
}

/* .navbar-op.active:hover span {
          color: #fff !important; 
      } */


@media (max-width: 536px) {
    .navbar-op.active:hover {
        background-color: none;
    }

    .navbar-op {
        font-size: 10px;
    }
}

@media (max-width: 767px) {
    .navbar-op.active {
        background-color: var(--mainBackColor);
        /* Quita el fondo amarillo */
        border-bottom: 2px solid var(--activeMainColor);
        /* Añade la línea inferior amarilla */
    }

    .navbar-op.active span {
        color: #fff !important;
    }

    .navbar-op::before,
    .navbar-op:hover::before {
        background-color: transparent;
        /* Quita la línea decorativa superior */
    }

    .navbar-og {
        background: var(--mainBackColor);
    }

    .navbar-op.active:hover {
        background-color: none
    }
}

.sticky-header {
    position: sticky;
    top: 0;
    background: #f12906;
    z-index: 5;
}
</style>